import React from 'react';
import SSMRadioButton from '../ssm-radio-button/ssm-radio-button';
import SSMRedirectTypeAndNumber from '../ssm-redirect-type-number/ssm-redirect-type-number';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import { Desktop, Mobile } from '../../../../app-responsive';

const ISDNRedirectTable = (props) => {
  const
    {
      siteServicesArray,
      authorableContent,
      onRedirectCancelClick,
      isdnRedirectCancelChecks,
      onIsdnRedirectTypeSelectionBlur,
      handleOnChangeRedirectNumber,
      handleOnBlurRedirectNumber,
      isdnRedirectNumberFieldError,
      siteId,
      isdnRedirectNumberData,
      isdnRedirectTypeData,
      showServicesErrorMessage,
    } = props;

  const getServiceTypeText = (type) => {
    switch (type) {
      case 'GDN':
        return authorableContent.gdnText;
      case 'PrimaryFNN' :
        return authorableContent.primaryFNN;
      default:
        return authorableContent.auxillary;
    }
  };

  const desktopRedirectCancelTable = siteServicesArray.map(service => (
    <div
      key={service.number}
      className="row table-border redirect-row"
    >
      <div className={`col-3 ${service.type.toLowerCase()}`}> {getServiceTypeText(service.type)} </div>
      <div className="col-3">{service.number}</div>
      <div className="col-3">
        { service.type !== 'Auxillary' &&
        <SSMRadioButton
          radioButtonId={`redirect-${service.type}-${service.number}`}
          radioButtonChecked={isdnRedirectCancelChecks && isdnRedirectCancelChecks[`redirect-${service.type}-${service.number}`]}
          radioButtonLabel={authorableContent.redirectText}
          onRadioButtonCallBackActionWithToggle={onRedirectCancelClick}
        />
        }
        { service.type === 'Auxillary'
          && isdnRedirectCancelChecks && isdnRedirectCancelChecks[`redirect-PrimaryFNN-${service.primaryFNN}`]
          && authorableContent.redirectWithPrimaryNumber
        }

      </div>
      <div className="col-3">
        { service.type !== 'Auxillary' &&
        <SSMRadioButton
          radioButtonId={`cancel-${service.type}-${service.number}`}
          radioButtonChecked={isdnRedirectCancelChecks && isdnRedirectCancelChecks[`cancel-${service.type}-${service.number}`]}
          radioButtonLabel={authorableContent.cancelText}
          onRadioButtonCallBackActionWithToggle={onRedirectCancelClick}
        />
        }
        { service.type === 'Auxillary'
          && isdnRedirectCancelChecks && isdnRedirectCancelChecks[`cancel-PrimaryFNN-${service.primaryFNN}`]
          && authorableContent.cancelText
        }
      </div>
      { isdnRedirectCancelChecks && isdnRedirectCancelChecks[`redirect-${service.type}-${service.number}`] &&
        <SSMRedirectTypeAndNumber
          redirectTypeId={`redirectType-${service.type}-${service.number}`}
          redirectDropDownFormFields={authorableContent.isdnRedirectDropDown}
          redirectTypeValue={isdnRedirectTypeData &&
            isdnRedirectTypeData[`redirectType-${service.type}-${service.number}`] ?
            isdnRedirectTypeData[`redirectType-${service.type}-${service.number}`] : ''}
          onRedirectTypeSelectionBlur={onIsdnRedirectTypeSelectionBlur}
          redirectNumberValue={isdnRedirectNumberData &&
            isdnRedirectNumberData[`redirectNumber-${service.type}-${service.number}`] ?
            isdnRedirectNumberData[`redirectNumber-${service.type}-${service.number}`] : ''
          }
          redirectNumberId={`redirectNumber-${service.type}-${service.number}`}
          redirectNumberTextField={authorableContent.isdnRedirectNumberTextField}
          handleOnChangeRedirectNumber={handleOnChangeRedirectNumber}
          handleOnBlurRedirectNumber={handleOnBlurRedirectNumber}
          redirectNumberFieldError={(showServicesErrorMessage &&
            isdnRedirectNumberData[`redirectNumber-${service.type}-${service.number}`] === undefined) ||
            (isdnRedirectNumberFieldError &&
            isdnRedirectNumberFieldError[`redirectNumber-${service.type}-${service.number}`])}
          redirectTypeFieldError={showServicesErrorMessage &&
             isdnRedirectTypeData[`redirectType-${service.type}-${service.number}`] === undefined}
        />
      }
    </div>
  ));

  const mobileRedirectCancelAll = (
    <div className="row redirect-cancel-all-mobile">
      <div className="col-6 ">
        <SSMRadioButton
          radioButtonId={`redirectAll-${siteId}`}
          radioButtonChecked={isdnRedirectCancelChecks && isdnRedirectCancelChecks[`redirectAll-${siteId}`]}
          radioButtonLabel={authorableContent.redirectAllText}
          onRadioButtonCallBackActionWithToggle={onRedirectCancelClick}
        />
      </div>
      <div className="col-6">
        <SSMRadioButton
          radioButtonId={`cancelAll-${siteId}`}
          radioButtonChecked={isdnRedirectCancelChecks && isdnRedirectCancelChecks[`cancelAll-${siteId}`]}
          radioButtonLabel={authorableContent.cancelAllText}
          onRadioButtonCallBackActionWithToggle={onRedirectCancelClick}
        />
      </div>
    </div>
  );

  const mobileRedirectCancelTable = siteServicesArray.map(service => (
    <div
      key={service.number}
      className="row table-border redirect-row"
    >
      <div className={`col-12 ${service.type.toLowerCase()}`}> {getServiceTypeText(service.type)} </div>
      <div className="col-6 migrate-fnn-mobile-col"><strong>{authorableContent.fnnText}</strong></div>
      { service.type === 'Auxillary'
          && isdnRedirectCancelChecks && isdnRedirectCancelChecks[`redirect-PrimaryFNN-${service.primaryFNN}`]
          &&
          <div className="col-6">
            <strong>{authorableContent.redirectWithPrimaryNumber}</strong>
          </div>
      }
      { service.type === 'Auxillary'
          && isdnRedirectCancelChecks && isdnRedirectCancelChecks[`cancel-PrimaryFNN-${service.primaryFNN}`]
          &&
          <div className="col-6">
            <strong>{authorableContent.cancelText}</strong>
          </div>
      }
      <div className="col-12 migrate-fnn-mobile-col-data">{service.number}</div>
      {service.type !== 'Auxillary' &&
        <div className="col-6">
          <SSMRadioButton
            radioButtonId={`redirect-${service.type}-${service.number}`}
            radioButtonChecked={isdnRedirectCancelChecks && isdnRedirectCancelChecks[`redirect-${service.type}-${service.number}`]}
            radioButtonLabel={authorableContent.redirectText}
            onRadioButtonCallBackActionWithToggle={onRedirectCancelClick}
          />
        </div>
      }
      {service.type !== 'Auxillary' &&
        <div className="col-6">
          <SSMRadioButton
            radioButtonId={`cancel-${service.type}-${service.number}`}
            radioButtonChecked={isdnRedirectCancelChecks && isdnRedirectCancelChecks[`cancel-${service.type}-${service.number}`]}
            radioButtonLabel={authorableContent.cancelText}
            onRadioButtonCallBackActionWithToggle={onRedirectCancelClick}
          />
        </div>
      }
      { isdnRedirectCancelChecks && isdnRedirectCancelChecks[`redirect-${service.type}-${service.number}`] &&
        <SSMRedirectTypeAndNumber
          redirectTypeId={`redirectType-${service.type}-${service.number}`}
          redirectDropDownFormFields={authorableContent.isdnRedirectDropDown}
          redirectTypeValue={isdnRedirectTypeData &&
            isdnRedirectTypeData[`redirectType-${service.type}-${service.number}`] ?
            isdnRedirectTypeData[`redirectType-${service.type}-${service.number}`] : ''}
          onRedirectTypeSelectionBlur={onIsdnRedirectTypeSelectionBlur}
          redirectNumberValue={isdnRedirectNumberData &&
            isdnRedirectNumberData[`redirectNumber-${service.type}-${service.number}`] ?
            isdnRedirectNumberData[`redirectNumber-${service.type}-${service.number}`] : ''
          }
          redirectNumberId={`redirectNumber-${service.type}-${service.number}`}
          redirectNumberTextField={authorableContent.isdnRedirectNumberTextField}
          handleOnChangeRedirectNumber={handleOnChangeRedirectNumber}
          handleOnBlurRedirectNumber={handleOnBlurRedirectNumber}
          redirectNumberFieldError={(showServicesErrorMessage &&
            isdnRedirectNumberData[`redirectNumber-${service.type}-${service.number}`] === undefined) ||
            (isdnRedirectNumberFieldError &&
            isdnRedirectNumberFieldError[`redirectNumber-${service.type}-${service.number}`])}
          redirectTypeFieldError={showServicesErrorMessage &&
             isdnRedirectTypeData[`redirectType-${service.type}-${service.number}`] === undefined}
        />
      }
    </div>
  ));

  return (
    <div className="serviceTable">
      <div className="row table-border headings hidden-mobile">
        <div className="col-6"><h2>{authorableContent.currentServiceDetailsText}</h2></div>
        <div className="col-6"><h2>{authorableContent.confirmOrderText}</h2></div>
      </div>
      <div className="row table-border column-headings hidden-mobile">
        <div className="col-3">
          <TextWithTooltip
            labelText={authorableContent.typeText}
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="isdn-redirect-table-type-tooltip"
            toolTipText={authorableContent.typeTooltipText}
          />
        </div>
        <div className="col-3">{authorableContent.fnnText}</div>
        <div className="col-3">
          <SSMRadioButton
            radioButtonId={`redirectAll-${siteId}`}
            radioButtonChecked={isdnRedirectCancelChecks && isdnRedirectCancelChecks[`redirectAll-${siteId}`]}
            radioButtonLabel={authorableContent.redirectAllText}
            onRadioButtonCallBackActionWithToggle={onRedirectCancelClick}
          />
        </div>
        <div className="col-3">
          <SSMRadioButton
            radioButtonId={`cancelAll-${siteId}`}
            radioButtonChecked={isdnRedirectCancelChecks && isdnRedirectCancelChecks[`cancelAll-${siteId}`]}
            radioButtonLabel={authorableContent.cancelAllText}
            onRadioButtonCallBackActionWithToggle={onRedirectCancelClick}
          />
        </div>
      </div>
      <Desktop>
        {desktopRedirectCancelTable}
      </Desktop>
      <Mobile>
        {mobileRedirectCancelAll}
        {mobileRedirectCancelTable}
      </Mobile>
    </div>
  );
};

export default React.memo(ISDNRedirectTable);
